import React from "react";

const Chapter10 = () => {
  return (
    <>
      <h2>
        What can I do to help reduce nutrients and other pollution in the South
        Platte River?
      </h2>
      <img
        style={{ width: "85%", margin: "20px auto" }}
        alt="why is wq important"
        src="/static/img/storylines/why_is_wq_import-01.png"
      />
      <p>
        PICK UP AND PROPERLY DISPOSE OF PET WASTE - Tie the bag up securely and
        place it in the garbage. This is important to do not only when out for a
        walk in the park, but also in your own backyard.
      </p>
      <p>
        DISPOSE OF TRASH PROPERLY - Trash on the ground ends up as trash in
        streams and lakes.
      </p>
      <p>
        DISPOSE OF HOUSEHOLD HAZARDOUS WASTE AND PHARMACEUTICALS PROPERLY –
        Contact your city or county to learn more about household hazardous
        waste disposal and medication take-back programs.
      </p>
      <p>
        MAINTAIN SEPTIC TANKS – Protect water quality by servicing septic
        systems annually.
      </p>
      <p>
        REPORT ILLEGAL DUMPING OR UNUSUAL CONDITIONS IN LAKES OR STREAMS - Be a
        watchdog over our lakes and streams.
      </p>
      <p>
        Green infrastructure and low impact development approaches and
        techniques help manage water and water pollutants at the source,
        preventing or reducing the impact of development on water quality. Learn
        about these cost-effective, sustainable, and environmentally friendly
        approaches to wet weather management.
      </p>
    </>
  );
};

export default Chapter10;
